import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NeoRol } from 'src/app/comun/models/neoRol';
import { NeoRolService } from 'src/app/comun/services/neoRol.service';
import { AlertService } from 'src/app/services/alert.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { UserService } from '../../../services/user.service';
import { NeoConsultaPerfilesIf } from '../../Model/neoConsultaPerfilesIF';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
declare var $: any;

@Component({
    selector: 'app-consulta-perfiles-if',
    templateUrl: './consulta-perfiles-if.component.html',
    styleUrls: ['./consulta-perfiles-if.component.scss'],
    providers: [
        NeoIntermediarioFinancieroService,
        NeoRolService
    ],
    standalone: false
})
export class ConsultaPerfilesIfComponent implements OnInit {
  listaRoles: NeoRol[] = [];
  listaEstados: string[] = [];
  mensajeError: string;
  public filtroConsultaPerfiles: NeoConsultaPerfilesIf;
  consultaPerfilesForm: UntypedFormGroup;
  fechaActual: String = new Date().toLocaleDateString('en-CA');
  listaUsuarios: any[] = [];
  paginaActual: Number = 1;
  public user;
  totalPaginas: Number = 1;

  constructor(
    private _neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
    private _neoRolService: NeoRolService,
    public router: Router,
    private alertService: AlertService,
    private _userIntermediarioService: UserService,
    private formBuilder: UntypedFormBuilder,
    private _sweetAlert:SweetAlertService) { }

  ngOnInit(): void {
    this.user = this._userIntermediarioService.getUser();
    this.consultaPerfilesForm = this.formBuilder.group({
      fechaInicio: [''],
      fechaFin: [''],
      estado: [''],
      listaRolesSeleccionadosId: ['']
    })

    this._neoRolService.getRolesIF().subscribe(
      (response) => {
        this.listaRoles = response['roles'];
      },
      (error) => {
        this.mensajeError = 'Error al cargar los roles';
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    )
    this.listaEstados.push('HABILITADO');
    this.listaEstados.push('INHABILITADO');

  }

  consultarUsuarios() {
    this.filtroConsultaPerfiles = this.consultaPerfilesForm.value;
    this.filtroConsultaPerfiles.roles = this.consultaPerfilesForm.get('listaRolesSeleccionadosId').value;
    this.filtroConsultaPerfiles.idCliente = this.user.idCliente;
    var fecha1 = this.consultaPerfilesForm.get('fechaInicio').value;
    var fecha2 = this.consultaPerfilesForm.get('fechaFin').value;
    if (this.validarFiltros(this.consultaPerfilesForm, this.filtroConsultaPerfiles)) {
      if (fecha2 >= fecha1) {
        this.listaUsuarios = [];
        let body: any = this.filtroConsultaPerfiles;
        body.page = this.paginaActual;
        body.paginado = true;
        this._neoIntermediarioFinancieroService.consultarPerfiles(body).toPromise()
          .then((result) => {
            if (result.exitoso == true) {
              this.mensajeError = '';
              this.listaUsuarios = result.respuestaUsuarios;
              this.totalPaginas = result.totalPages;
              if (result.exitoso == false) {
                this.mensaje();
              }
            } else {
              this.mensaje();
            }
          }).catch((err) => {
            this.mensajeError = 'Error al consultar usuarios';
          });
      } else {
        this._sweetAlert.errorModal("Error!",true,'La fecha inicial no puede ser mayor a la fecha final');
      }
    }

  }
  mensaje() {
    $('#mensajeModal').modal('show');
  }

  validarFiltros(consultaPerfilesForm: UntypedFormGroup, filtroConsultaPerfiles: NeoConsultaPerfilesIf): boolean {
    let exito = true;
    if (consultaPerfilesForm.value.fechaInicio == '' && consultaPerfilesForm.value.fechaFin == ''
      && consultaPerfilesForm.value.estado == '' && consultaPerfilesForm.value.roles == '') {
      this._sweetAlert.errorModal("Error!",true,'Debe seleccionar un criterio de busqueda');
      exito = false;
      return exito;
    }

    if ((consultaPerfilesForm.value.fechaInicio == '' && consultaPerfilesForm.value.fechaFin != '')
      || (consultaPerfilesForm.value.fechaInicio != '' && consultaPerfilesForm.value.fechaFin == '')) {
      this._sweetAlert.errorModal("Error!",true,'Debe seleccionar los dos rangos de fecha');
      exito = false;
      return exito;
    }

    if (consultaPerfilesForm.value.roles == '') {
      filtroConsultaPerfiles.roles = null;
    }

    return exito;
  }

  descargarExcel() {
    this._neoIntermediarioFinancieroService.dowloadExcelPerfiles(this.filtroConsultaPerfiles).
      subscribe((response: any) => {
        if (response.exitoso == true) {
          var a = document.getElementById('downloadFile');
          a.setAttribute('href', `data:${response.mimeType};base64,${response.data}`);
          a.setAttribute('download', unescape(response.fileName));
          a.click();
        }
      })
  }

  descargarTxt() {
    this._neoIntermediarioFinancieroService.dowloadTxtPerfiles(this.filtroConsultaPerfiles).
      subscribe((response: any) => {
        if (response.exitoso == true) {
          var a = document.getElementById('downloadFile');
          a.setAttribute('href', `data:${response.mimeType};base64,${response.data}`);
          a.setAttribute('download', unescape(response.fileName));
          a.click();
        }
      })
  }

  selectPage(page: number) {
    this.paginaActual = page;
    this.consultarUsuarios();
  }

}
